/** Stream service event names */
export enum STREAM_EVENTS {
    /** Used for injesting new SMS sourcesd location input events */
    NEW_TEXT_MESSAGE_INPUT = 'new-text-message-input',
    NEW_TEXT_MESSAGE_INPUT_CASE_TRANSFER = 'new-text-message-input-case-transfer',
    NEW_TEXT_MESSAGE_INPUT_API = 'new-text-message-input-api',
    /** Used for injesting new rapisos location input events */
    NEW_RAPIDSOS_LOCATION = 'new-rapidsos-location',
    /** Used for tracking whether a caller is sharing location */
    IS_SHARING_LOCATION = 'is-sharing-location',
    /** Used for tracking whether a caller is connected to socketio */
    IS_SHARING_LOCATION_BY_NUMBER = 'is-sharing-location-by-number',
    /** Used for tracking whether an alert portal participant is sharing location */
    IS_SHARING_LOCATION_BY_TARGETID = 'is-sharing-location-by-targetid',
    /** Used for tracking whether a caller is connected to socketio */
    CALLER_CONNECTED = 'caller-connected',
    /** Used for tracking whether an observer is watching the search */
    OBSERVER_CONNECTED = 'observer-connected',
    /** Used for tracking whether a caller has the browser tab focused */
    IS_TAB_FOCUSED = 'is-tab-focused',
    /** Used for tracking whether a n overwatch caller has the browser tab focused */
    IS_TAB_FOCUSED_BY_NUMBER = 'is-tab-focused-by-number',
    /** Used for tracking whether a caller had an error sharing location */
    LOCATION_SHARING_ERROR = 'location-sharing-error',
    /** Used when an alert portal participant submits evidence */
    EVIDENCE_SUBMITTED_BY_NUMBER = 'evidence-submitted-by-number',
    /** Used when an alert portal participant submits emergency contact information */
    ALERT_PORTAL_INFORMATION_SUBMITTED = 'alert-portal-information-submitted',
    /** Used for injesting and reemitting events for socketio */
    SOCKET_IO = 'socketio',
    /** When you need to emit an event but don't want it to have an effect  */
    DO_NOTHING = 'donothing',
    /** Stream event to trigger admin transfer request */
    TEAMTRACK_CASE_TRANSFER_REQUESTED = 'teamtrack-case-transfer-requested',
    /** Stream event to trigger overwatch transfer request */
    OVERWATCH_CASE_TRANSFER_REQUESTED = 'overwatch-case-transfer-requested',
    /** Ensures transfer between old and new requests */
    OVERWATCH_TRANSFER_CALLER = 'overwatch-transfer-caller',
}

/** Streamservice events caught and acted on by the socketio listeners */
export enum SOCKETIO_EVENTS {
    /** Used for client to sent new text message sourced locations to socketio server */
    TEXT_MESSAGE_LOCATION_UPDATE = 'text-message-location-update',
    /** Used for emiting new locations to socketio */
    NEW_LOCATION_AVAILABLE = 'new-location-available',
    /** Used for emiting new API locations to socketio */
    NEW_LOCATION_AVAILABLE_API = 'new-location-available-api',
    /** Used for tracking whether a caller is sharing location */
    IS_SHARING_LOCATION = 'is-sharing-location',
    /** Used for tracking whether a caller is connected to socketio */
    IS_SHARING_LOCATION_BY_NUMBER = 'is-sharing-location-by-number',
    /** Used for tracking whether an alert portal participant is sharing location */
    IS_SHARING_LOCATION_BY_TARGETID = 'is-sharing-location-by-targetid',
    /** Used for tracking whether a caller is connected to socketio */
    CALLER_CONNECTED = 'caller-connected',
    /** Used for tracking whether an observer is watching the search */
    OBSERVER_CONNECTED = 'observer-connected',
    /** Used for tracking whether a caller has the browser tab focused */
    IS_TAB_FOCUSED = 'is-tab-focused',
    /** Used for tracking whether a n overwatch caller has the browser tab focused */
    IS_TAB_FOCUSED_BY_NUMBER = 'is-tab-focused-by-number',
    /** Used for tracking whether a caller had an error sharing location */
    LOCATION_SHARING_ERROR = 'location-sharing-error',
    /** Used for notifying the client they they have finished conncting to the server */
    CONNECT_COMPLETE = 'connect-complete',
    /** Used for notifying the client that they need to reconnect with a different token */
    UPDATE_CONNECTION_TOKEN = 'update-connection-token',
    /** Used when an alert portal participant submits evidence */
    EVIDENCE_SUBMITTED_BY_NUMBER = 'evidence-submitted-by-number',
    /** Used when an alert portal participant submits emergency contact information */
    ALERT_PORTAL_INFORMATION_SUBMITTED = 'alert-portal-information-submitted',
    /** Stream event to trigger admin transfer request */
    TEAMTRACK_CASE_TRANSFER_REQUESTED = 'teamtrack-case-transfer-requested',
    /** Stream event to trigger overwatch transfer request */
    OVERWATCH_CASE_TRANSFER_REQUESTED = 'overwatch-case-transfer-requested',
    /** Moves one Overwatch caller onto a transferred connection request */
    OVERWATCH_TRANSFER_CALLER = 'overwatch-transfer-caller',
}
